import type { KycStatus } from "../shared/types"

export const isTerminalStatus = (status: KycStatus | null) =>
  status === "accepted" || status === "declined" || status === "cancelled" || status === "timeout"

export const isPendingStatus = (status: KycStatus | null) => status === "pending" || status === "review_pending"
